import React, { Component } from "react";
import "./style.scss";

import { QuestionTable as QT} from "@learningblocks/exp-components";

export class QuestionTable extends Component {

  doneClicked =()=>{
    this.props.showModal({
      display: false
    })
  }

  render() {
    const data = {
      "id": 0,
      "type": "QUESTION_TABLE",
      "content": [
        "table",
        "heading",
        "text"
      ],
      "question": "In order to have enough DNA to visualize on the gel, you will need to add 10µl of each PCR sample you want to run. You will also need to add 2µl of loading dye to each sample. Please enter the volumes of each reagent needed in each sample into the table below.",
      "totalAttempts": 3,
      "heading":"PREDICTION QUESTION",
      "text": "In the table below, select the genotype from the dropdown list that best matches the phenotypes in the same column.",
      "indices": [4, 6],
      "data": [
        [
          {"type": "TITLE", "text": "Reagents"},
          {"type": "TITLE", "text": "Unk. sample"},
          {"type": "TITLE", "text": "Pos. control D/D"},
          {"type": "TITLE", "text": "Pos. control I/D"},
          {"type": "TITLE", "text": "Pos. control I/I"},
          {"type": "TITLE", "text": "Negative control"}
        ],
        [
          {"type": "TITLE", "text": "Loading dye (LD)"},
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          }
        ],
        [
          {"type": "TITLE", "text": "PCR sample"},
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          }
        ],
        [
          {"type": "TITLE", "text": "total amount to load on gel"},

          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          },
          {
            "type": "INPUT", "value": "", "placeholder" : "Enter μl",
            "inputType" : "text",
            "disabled" : false
          }
        ]
      ]
  }
    return (
      <div className="modal-section mastermix-poster"
      style={{
        width: "calc(100% - 0px)",
        //height: "650px",
        margin: "auto",
      }}
      >
        <div className="modal-header">
          <h2>FILL IN THE TABLE</h2>
        </div>
        <div className="modal-body" style={{background: 'none', border: 'none', marginBottom: '16px', padding: '0'}}>
        <QT
          isProtocolQuestionTable={true}
          {...data}
         />

        </div>
        {/* <div className="modal-footer">
          <div
            style={{
              justifySelf: "flex-start",
              marginRight: "auto",
            }}
          >
            <p>
              Hit the "Next" button when you want to move on.
            </p>
          </div>
          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={() => this.finishStep()}
          >
            Next
          </button>
        </div> */}
      </div>
    );
  }
}
